var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-fax fa-lg",attrs:{"aria-hidden":"false","title":_vm.uLang('app.book_invoice')},on:{"click":_vm.bookInvoice}})
}
var staticRenderFns = []

export { render, staticRenderFns }